import { render, staticRenderFns } from "./WeekdayPrice.vue?vue&type=template&id=dd9305e2&scoped=true"
import script from "./WeekdayPrice.vue?vue&type=script&lang=js"
export * from "./WeekdayPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9305e2",
  null
  
)

export default component.exports